// extracted by mini-css-extract-plugin
module.exports = {"container":"subscribe_container__QNHHH","input":"subscribe_input__IPYfm","content":"subscribe_content__XBhfe","desc":"subscribe_desc__3hXio","form":"subscribe_form__cd_7l"};